import { GamePhase, PrizeBoxState } from './prize-box-page.types';

export const MINIMUM_POINTS_TO_PLAY = 30; // Play cost in points
export const DEFAULT_CREDITS_ATTEMPTS = 3; // per window; contract returns actual attempts
export const DAY_MS = 24 * 3600 * 1000;
export const USD = 'USD';

export const PLAY_COST = 30; // spent to enter a round
export const DRAW_REWARD = 20; // points awarded on draw
export const LOSS_PENALTY = 30; // points lost on loss

export const DRAW_COST = DRAW_REWARD;
export const LOSE_COST = LOSS_PENALTY;
export const WIN_COST = PLAY_COST;

export const FALLBACK_POINTS_ON_ZERO_WIN = 50;

export const PERCENT_BY_TOPHAND = [10, 20, 30, 40, 50, 70, 90, 100]; // /500 in docs

export const sectionStyles =
  'relative z-10 w-full lg:bg-[linear-gradient(0deg,#080540,#080540),radial-gradient(50%_50%_at_50%_50%,rgba(0,11,255,0.3)_0%,rgba(1,0,29,0.3)_100%)] lg:border lg:border-[3px] lg:border-border rounded-3xl p-3 lg:p-6 lg:mt-6 mt-4 h-full mx-auto max-w-screen-sm';

export const initialState: PrizeBoxState = {
  loading: false,
  error: null,
  phase: GamePhase.Idle,
  selectedMove: null,
  aiMove: null,
  result: null,
  playerWins: 0,
  aiWins: 0,
  lastMoves: null,
  lastRoundOutcome: null,
  pool: 0,
  points: 0,
  quotaResetAt: 0,
  extraCredits: 0,
  snapshotPoints: 0,
  currentSlotBalance: 0,
  topHands: null,
  recoveryAmount: 0,
};
